import { KYMW0905Component } from './kymw0905.component';

/**
 * 商品企画栄養成分情報メンテナンス画面の値を管理するクラス
 *
 * @export KYMW0905Model
 * @class KYMW0905Model
 */
export class KYMW0905Model {

  kymw0905Component: KYMW0905Component;

  // 編集有無フラグ
  public isEdited: boolean = <boolean>false;

  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  // アイテムコード
  public itemCode: string = <string>'';

  // 商品案内用商品名
  public guideGoodsName: string = <string>'';

  // 商品案内用規格名
  public guideStandardName: string = <string>'';

  // 分析連番
  public analysisSeqNo: string = <string>'';

  // 分析単位
  public analysisUnit: string = <string>'';

  // 栄養成分備考
  public nutritionalNote: string = <string>'';

  // 栄養成分リスト
  public nutrientDetailList: Array<any> = null;

  // 栄養成分リスト (画面呼び出し直後、設定ボタン押下直後のバックアップ)
  public nutrientDetailListBk: Array<any> = null;

  // 権限ID　「1」は閲覧モード「２」フルコントロール
  public funcPermission: string = <string>'';
}
